import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_tenant_participants: { message: "idle" },
};

export const retrieve_tenant_participants_Slice = createSlice({
 name: "retrieve_tenant_participants",
 initialState,
 reducers: {
  success_retrieve_tenant_participants: (state, action) => {
   state.retrieve_tenant_participants = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_tenant_participants: (state, action) => {
   state.retrieve_tenant_participants = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_tenant_participants: (state) => {
   state.retrieve_tenant_participants = { status: app_consts.IDLE };
  },
  loading_retrieve_tenant_participants: (state) => {
   state.retrieve_tenant_participants = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_tenant_participants, fail_retrieve_tenant_participants, reset_retrieve_tenant_participants, loading_retrieve_tenant_participants } = retrieve_tenant_participants_Slice.actions;

export default retrieve_tenant_participants_Slice.reducer;